import customAxios from "./axiosConfig";

const EUServicesReportService = {
    get: function (id, params) {
        var api_url = window.Urls['euservicesreport_detail'](id);
        return customAxios.get(api_url, { params: params });
    },
    list: function (params) {
        var api_url = window.Urls['euservicesreport_list']();
        return customAxios.get(api_url, { params: params });
    },
    update: function (id, data) {
        var api_url = window.Urls['euservicesreport_detail'](id);
        return customAxios.patch(api_url, data);
    },
    create: function (data) {
        var api_url = window.Urls['euservicesreport_list']();
        return customAxios.post(api_url, data);
    },
    count: function (params) {
        var api_url = window.Urls['euservicesreport_count']();
        return customAxios.get(api_url, { params: params });
    },
    destroy: function (id) {
        var api_url = window.Urls['euservicesreport_detail'](id);
        return customAxios.delete(api_url);
    },
    recalculate: function (id, data) {
        var api_url = window.Urls['euservicesreport_detail'](id);
        return customAxios.put(api_url, data);
    }
};

export default EUServicesReportService;